import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { SuperAdminAuthContext } from "../context/SuperAdminAuthContext.jsx";
import SuperAdminLayout from "./SuperAdminLayout.jsx";

export default function SuperAdminProtectedRoute({ children }) {
  const { superAdmin, loading, isAuthenticated } = useContext(SuperAdminAuthContext);

  if (loading) return <div className="center">Loading...</div>;
  if (!isAuthenticated || !superAdmin) return <Navigate to="/superadmin/login" replace />;
  return <SuperAdminLayout>{children}</SuperAdminLayout>;
}

